import { Expose, Type } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";

export class HouseholdClaimAssets extends BaseModel {
    @Expose() id = "";
    @Expose() value = "";
    @Expose() label = "";
    @Expose()
    @Type(() => HouseholdClaimAssets)
    children: HouseholdClaimAssets[] = [];
}
